import React from 'react'
import Faq from './Faq'
import ConatctForm from './homepage/ConatctForm'
import { Link } from 'react-router-dom'


const ContactUs = () => {
    return (
        <>

        <div className="btn-wrapper fixed-btn">
                  <Link to="/book-a-demo"><button className="ax-custom-banner-sec-btn">
                    Book Your   Free Demo Now
                  </button> </Link>
                </div>


            {/* Contact detail-section */}
            <section className="ax-contactact-section-main">
                <div className="container py-5 position-relative" style={{ zIndex: 1 }}>
                    <div className="row align-items-start">
                        <div className="col-lg-7 mb-5 mb-lg-0">
                            <span className="ax-contactact-section-pixel-heading">CONTACT</span>
                            <h1 className="ax-contactact-section-team-heading">
                                Our <span>Team</span>
                            </h1>
                            <p className="ax-contactact-section-sub-text">
                                Contact us to know more about us and our work processes or in case
                                you have a project query.
                            </p>
                            <div>
                                <a href="#" className="ax-contactact-section-social-link"><i className="fab fa-linkedin-in" /></a>
                                <a href="#" className="ax-contactact-section-social-link"><i className="fab fa-facebook-f" /></a>
                                <a href="#" className="ax-contactact-section-social-link"><i className="fab fa-twitter" /></a>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <h2 className="ax-contactact-section-address-title">Address</h2>
                            <div className="mb-4">
                                <span className="ax-contactact-section-info-label">Head Office</span>
                                <p className="ax-contactact-section-info-detail">
                                      Axepert Exhibits Pvt. Ltd.
                                </p>
                               
                                <p className="ax-contactact-section-info-detail">KD-3, Pitampura, New Delhi-110034. </p>
                            </div>
                            <div>
                                <span className="ax-contactact-section-info-label">Contact</span>
                                <p className="ax-contactact-section-info-detail">+91 011-43220041</p>
                                <p className="ax-contactact-section-info-detail">
                                  mail@axesell.com
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="ax-contactact-section-bg-shape" /> */}
            </section>





            {/* <ConatctForm /> */}
            {/* <section className="ax-image-wrapper">
                <div className="ax-image-box">
                    <img src="/assets/images/img.png" alt="team" />
                </div>
            </section> */}
            {/* <Faq /> */}
        </>
    )
}

export default ContactUs